export const IS_ACTIVE_BUTTON_OWNER_MOBILI = 'IS_ACTIVE_BUTTON_OWNER_MOBILI'
export const IS_LOADING_BUTTON_OWNER_MOBILI = 'IS_LOADING_BUTTON_OWNER_MOBILI'
export const IS_LOADING_FORM_OWNER_MOBILI = 'IS_LOADING_FORM_OWNER_MOBILI'
export const FORM_DATA_OWNER_MOBILI = 'FORM_DATA_OWNER_MOBILI'
